document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabbed-content-section.tabbed-content-section-rotate').forEach(section => {
    const tabs = Array.from(
      section.querySelectorAll('[data-bs-toggle="collapse"]')
    );

    if (tabs.length <= 1) return;

    let isPaused = false;

    function advanceTab() {
      if (isPaused) return;
      var visibleNavItems = Array.from(
        document.querySelectorAll<HTMLElement>("#audience-navigation-desktop .main-navigation-item-collapse.show")
      ).filter((el) => el.offsetParent !== null);

      var visibleUtilityNavItems = Array.from(
        document.querySelectorAll<HTMLElement>(".utility-navigation-item-collapse.show")
      ).filter((el) => el.offsetParent !== null);

      var visibleHeaderMobile = Array.from(
        document.querySelectorAll<HTMLElement>(".header-mobile")
      ).filter((el) => el.offsetParent !== null);

      var visibleMobileNavItems = Array.from(
        document.querySelectorAll<HTMLElement>("#headerOffcanvas.show")
      );

      if (visibleNavItems.length > 0 || visibleUtilityNavItems.length > 0 || (visibleHeaderMobile.length > 0 && visibleMobileNavItems.length > 0)) return;

          const currentIndex = tabs.findIndex(tab => !tab.classList.contains('collapsed') ||
              tab.getAttribute('aria-selected') === 'true'
          );

          const nextIndex = currentIndex === -1 || currentIndex === tabs.length - 1
              ? 0
              : currentIndex + 1;

      let nextTabElementlement: HTMLElement = tabs[nextIndex] as HTMLElement;
      nextTabElementlement.click();
      }

    const interval = setInterval(advanceTab, 8000);

    section.addEventListener('mouseenter', () => {
      isPaused = true;
    });

    section.addEventListener('mouseleave', () => {
      isPaused = false;
    });

    const observer = new MutationObserver(() => {
      if (!document.body.contains(section)) {
        clearInterval(interval);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
});
